import React, { Component } from 'react'
import EnvBanner from '../EnvBanner'
import getEnvVariableValue, { VARIABLES } from 'src/utils/getEnvVariableValue'
import Left from 'src/components/LayoutWrapper/Left'
import styles from './layoutWrapper.module.scss'
import BackgroundImg from 'src/components/BackgroundImage'

const envBannerVariant = getEnvVariableValue(VARIABLES.ENV_BANNER)

class LayoutWrapper extends Component {
    static Left = Left

    static Main = ({ children }) => {
        return (
            <div
                role={'region'}
                aria-label={'main'}
                className={styles.layoutWrapperMain}
            >
                <BackgroundImg />
                {children}
            </div>
        )
    }

    render() {
        return (
            <>
                <EnvBanner variant={envBannerVariant} />
                <div className={styles.layoutWrapper}>
                    {this.props.children}
                </div>
            </>
        )
    }
}

export default LayoutWrapper
